import { render, staticRenderFns } from "./PotentialWidget.vue?vue&type=template&id=42b9758c&"
import script from "./PotentialWidget.vue?vue&type=script&lang=js&"
export * from "./PotentialWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports